module.exports = __webpack_public_path__ + "static/media/plaza-1.c288f3f2.webp";